__webpack_require__.p = "https://static.klouser.app/builds/klouser-ui-stg-20260612-163642/";